import View from '../view.js';

export default class Baseview extends View {
  render_template(data, tpl) {
    // eslint-disable-line camelcase
    return this.renderTemplate(
      data,
      tpl === undefined ? this.jst_template : tpl,
    ); // eslint-disable-line camelcase
  }

  renderTemplate(data, template) {
    template = template === undefined ? this.jstTemplate : template;
    if (template) {
      return JST['templates/' + template](data);
    }
    return this;
  }
}
